import React, { useState, useRef, useEffect, useContext } from "react";
import { Editor } from "primereact/editor";
import "./RichText.css"; // Import CSS file for custom styling
import axios from "axios";
import Swal from "sweetalert2";
import UserContext from '../../Context/User/userContext.jsx';

function RichText({ setShowSpinner }) {
    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : ""

    // User Object
    const { user, setUser } = useContext(UserContext);
    const userObj = typeof user === 'string' ? JSON.parse(user) : user;

    const getData = () => {
        setShowSpinner(true);
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/richtext?addedById=${userObj._id}`;
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                setText(res.data.data[0] ? res.data.data[0].content : "")
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response?.data?.message,
                });
            })
        setShowSpinner(false);
    }

    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])

    const [text, setText] = useState('');
    const editorRef = useRef(null);

    const handleTextChange = (e) => {
        setText(e.htmlValue);
    };


    const handleSubmit = async () => {
        setShowSpinner(true);
        // Staff information
        const textObj = {
            content: text,
            addedBy: userObj._id,
        };
        // URL for saving Facility information
        const saveUrl = 'https://research-mate-b35a10757d5a.herokuapp.com/api/richtext';

        // Make the API request to save text information
        axios.post(saveUrl, textObj, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                Swal.fire({
                    title: "Added!",
                    text: "Your Facility has been added",
                    icon: "success",
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                getData();
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response?.data?.message || error.message,
                });
            })
            .finally(() => {
                setShowSpinner(false);
            })
    };

    return (
        <div className="container">
            <div>
                <h3 style={{ color: '#169a8f', textAlign: 'center', fontFamily: 'cursive' }}>Equipment & Machineries available at your Site</h3>
            </div>
            <div className="d-flex justify-content-end">
                <button className="button " data-text="Awesome" onClick={handleSubmit}>
                    <span className="actual-text">&nbsp;SaveFacility&nbsp;</span>
                    <span aria-hidden="true" className="hover-text">&nbsp;SaveFacility&nbsp;</span>
                </button>
            </div>
            <div className="card mt-4">
                <Editor
                    value={text}
                    onTextChange={handleTextChange}
                    // onSelectionChange={handleSelectionChange}
                    style={{ height: '320px' }}
                    ref={editorRef}
                />
            </div>
        </div>
    );
}

export default RichText;
